import * as React from 'react';
import { useAccountTwrrDate } from '../../hooks';
import { ActorApiDateDisplay } from '../../../../../../components/display/date';

export const AccountsTwrrTAccTwrrPDate = (props: {
  format?: string,
}) => {
  const {
    data,
    isLoading,
    error,
  } = useAccountTwrrDate();
  const {
    format,
  } = props;
  return (
    <ActorApiDateDisplay
      data={data}
      isLoading={isLoading}
      error={error}
      format={format}
      capitalized
    />
  );
};
